$(document).ready(function () {
  const modal = document.getElementById('projectModal');

  if (modal === null) {
    return ;
  }

  modal.addEventListener("show.bs.modal", function(event){
    const tab = document.getElementById(event.relatedTarget.dataset.modalTabSelect);
    tab.click();
  });
});
